<script lang="ts">
  import HeroSection from '$lib/sections/HeroSection.svelte';
  import HeroStageSection from '$lib/sections/HeroStageSection.svelte';
  import TheGapSection from '$lib/sections/TheGapSection.svelte';
  import ThreePathsSection from '$lib/sections/ThreePathsSection.svelte';
  import ControlSection from '$lib/sections/ControlSection.svelte';
  import WhoItsForSection from '$lib/sections/WhoItsForSection.svelte';
  import WhatYouGetSection from '$lib/sections/WhatYouGetSection.svelte';
  import ContactCtaSection from '$lib/sections/ContactCtaSection.svelte';
  import GridLines from '$lib/components/GridLines.svelte';
  import Star from '$lib/components/Star.svelte';
  import PageMeta from '$lib/components/PageMeta.svelte';
  import { hatchStyle45 } from '$lib/styles/hatch';
</script>

<PageMeta
  title="Corral AI — Bring the AI in. Make it your own."
  description="Deploy a complete AI foundation into your cloud in 30 minutes. Connect your data, build agents for your workflows, and shape AI to how your business actually works — without the $500K build."
  canonicalUrl="https://getcorral.ai"
/>

<!-- Top stars sitting on the header border -->
<div class="relative">
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute left-[calc(9.03%-9px)] -top-px" />
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute right-[calc(9.03%-9px)] -top-px" />
</div>

<!-- §1a Hero (light, hatch) — copy + CTAs only -->
<HeroSection />

<!-- §1b Hero stage (black, sticky, horizontal scroll) — the 3-phase product tour -->
<HeroStageSection />

<!-- Divider Hero stage (black) → The Gap (dark) — short visual lift -->
<div class="h-[64px] bg-gradient-to-b from-[#0a0a0a] to-[#0d0d0d] relative">
  <GridLines variant="dark" />
  <div class="hidden lg:block absolute bottom-0 left-0 right-0 h-px bg-[#333335]" aria-hidden="true"></div>
  <Star variant="full" class="hidden lg:block absolute left-[calc(9.03%-9px)] bottom-[-9px]" />
  <Star variant="full" class="hidden lg:block absolute right-[calc(9.03%-9px)] bottom-[-9px]" />
</div>

<!-- §2 The Gap (dark) -->
<TheGapSection />

<!-- Divider Gap (dark) → Three Paths (light) -->
<div class="h-[48px] bg-[#0d0d0d] relative">
  <GridLines variant="dark" />
  <div class="hidden lg:block absolute bottom-0 left-0 right-0 h-px bg-[#D3D3D3]" aria-hidden="true"></div>
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute left-[calc(9.03%-9px)] bottom-[-9px]" />
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute right-[calc(9.03%-9px)] bottom-[-9px]" />
</div>

<!-- §3 Three Paths (light) -->
<ThreePathsSection />

<!-- Divider Three Paths (light) → Control (dark) -->
<div class="h-[48px] bg-[#f9f9f4] relative" style={hatchStyle45}>
  <GridLines variant="light" />
  <div class="hidden lg:block absolute bottom-0 left-0 right-0 h-px bg-[#D3D3D3]" aria-hidden="true"></div>
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute left-[calc(9.03%-9px)] bottom-[-9px]" />
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute right-[calc(9.03%-9px)] bottom-[-9px]" />
</div>

<!-- §4 Control + Sovereignty (dark) -->
<ControlSection />

<!-- Divider Control (dark) → Who It's For (light) -->
<div class="h-[48px] bg-[#0d0d0d] relative">
  <GridLines variant="dark" />
  <div class="hidden lg:block absolute bottom-0 left-0 right-0 h-px bg-[#D3D3D3]" aria-hidden="true"></div>
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute left-[calc(9.03%-9px)] bottom-[-9px]" />
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute right-[calc(9.03%-9px)] bottom-[-9px]" />
</div>

<!-- §5 Who It's For (light) -->
<WhoItsForSection />

<!-- Divider Who (light) → What You Get (light) — no transition line, just pacing to let the personas breathe -->
<div class="h-[48px] bg-[#f9f9f4] relative" style={hatchStyle45}>
  <GridLines variant="light" />
</div>

<!-- §6 What You Get (light) -->
<WhatYouGetSection />

<!-- Divider What You Get (light) → CTA (black) -->
<div class="h-[48px] bg-[#f9f9f4] relative">
  <GridLines variant="light" />
  <div class="hidden lg:block absolute bottom-0 left-0 right-0 h-px bg-[#D3D3D3]" aria-hidden="true"></div>
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute left-[calc(9.03%-9px)] bottom-[-9px]" />
  <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute right-[calc(9.03%-9px)] bottom-[-9px]" />
</div>

<!-- §7 CTA Close (black) — landing-specific three-CTA composition -->
<ContactCtaSection
  headline="Bring the AI in. Make it yours. Today."
  subhead="30 minutes from Azure Marketplace to a working instance in your cloud. Connect your data, build agents for your workflows, and start shaping AI to your business — without the $500K build."
  primaryCta={{ label: 'Deploy on Azure Marketplace', href: 'https://azuremarketplace.microsoft.com' }}
  secondaryCta={{ label: 'Join Design Partner Program', href: '/partners' }}
  contactButtonLabel="Talk to us"
/>
